import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-matdialog',
  templateUrl: './matdialog.component.html',
})
export class MaterialDialogComponent {
  isDesktop: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<MaterialDialogComponent>) {
    this.dialogRef.disableClose = true;
    this.isDesktop = this.isNotMobile();
    // setTimeout(() => {
    //   const scrollTop = $(window).scrollTop();
    //   window.scrollTo(0, scrollTop);
    // });
  }

  private isNotMobile() {
    const ua = navigator.userAgent;
    if (this.isTablet()) {
      return true;
    }
    if (/Mobile|iP(hone)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return false;
    }
    return true;
  }

  private isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
  }
}
